import { PluginIdentifierEnum, PluginStatusEnum } from 'api/enums';

/* -------------------------------------------------------------------------------------------------
 * IPluginModel
 * -----------------------------------------------------------------------------------------------*/
export interface IPluginModel {
    _id: string;
    name: string;
    logoUrl: string;
    description: string;
    identifier: PluginIdentifierEnum;
    status: PluginStatusEnum;
    isActive: boolean;
}

/* -------------------------------------------------------------------------------------------------
 * PluginModel
 * -----------------------------------------------------------------------------------------------*/
export class PluginModel {
    _id: string;
    name: string;
    logoUrl: string;
    description: string;
    identifier: PluginIdentifierEnum;
    status: PluginStatusEnum;
    isActive: boolean;

    constructor(data: Partial<IPluginModel>) {
        this._id = data._id ?? '';
        this.name = data.name ?? '';
        this.logoUrl = data.logoUrl ?? '';
        this.description = data.description ?? '';
        this.identifier = data.identifier ?? null;
        this.status = data.status ?? null;
        this.isActive = data.isActive ?? null;
    }

    static fromObject(data: Partial<IPluginModel>): PluginModel {
        const model = new PluginModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IPluginModel>[]): PluginModel[] {
        return data.map((row) => PluginModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IPluginModel>): PluginModel {
        const model = new PluginModel(data);

        return model;
    }

    toObject(): IPluginModel {
        const data: IPluginModel = {
            _id: this._id,
            name: this.name,
            logoUrl: this.logoUrl || null,
            description: this.description || null,
            identifier: this.identifier,
            status: this.status,
            isActive: this.isActive,
        };

        return data;
    }
}
